/**
 * Labstep
 */

import { updateAmountActionComponentProps } from 'labstep-web/components/ProtocolValue/Action/UpdateAmount/constants';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalConfirmation as Modal } from 'labstep-web/core/Modal/Confirmation';
import type React from 'react';
import type { IProtocolValueActionUpdateAmountModalProps } from './types';
import { getHeaderAndMessage } from './utils';

export const ProtocolValueActionUpdateAmountModal: React.FC<
  IProtocolValueActionUpdateAmountModalProps
> = ({ protocolValue }) => {
  const { header, message } = getHeaderAndMessage(protocolValue);

  return (
    <Modal
      header={header}
      message={message}
      cancelButtonContent="Okay"
      confirmButtonContent={false}
      onConfirm={(): null => null}
      children={
        <ActionComponent {...updateAmountActionComponentProps} />
      }
    />
  );
};
